import { defineStore } from 'pinia';

// Client-side run state shared between SOP walkthroughs of one conversation.
// Walkthroughs are separate components, so a SOP that references another one
// needs this to know whether the referenced run is complete and which
// referenced SOPs should currently be shown as tabs.
const keyFor = (conversationId, sopId) => `${conversationId}:${sopId}`;

export const useSopRunsStore = defineStore('sopRuns', {
  state: () => ({
    // { [`${conversationId}:${sopId}`]: 'in_progress' | 'completed' }
    statuses: {},
    // { [`${conversationId}:${referrerSopId}`]: [referencedSopId, ...] }
    references: {},
  }),
  getters: {
    isCompleted: state => (conversationId, sopId) =>
      state.statuses[keyFor(conversationId, sopId)] === 'completed',
    // Referenced SOP id -> ids of the SOPs that reference it, for one conversation.
    referrersByTarget: state => conversationId => {
      const prefix = `${conversationId}:`;
      const result = {};
      Object.entries(state.references).forEach(([key, targetIds]) => {
        if (!key.startsWith(prefix)) return;
        const referrerId = Number(key.slice(prefix.length));
        targetIds.forEach(targetId => {
          result[targetId] = [...(result[targetId] || []), referrerId];
        });
      });
      return result;
    },
  },
  actions: {
    setStatus(conversationId, sopId, status) {
      this.statuses[keyFor(conversationId, sopId)] = status;
    },
    setReferences(conversationId, sopId, targetIds) {
      this.references[keyFor(conversationId, sopId)] = targetIds;
    },
    clearReferences(conversationId, sopId) {
      delete this.references[keyFor(conversationId, sopId)];
    },
  },
});
